var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"audio-route-icon"},[_c(_setup.SvgIcon,{directives:[{name:"tap",rawName:"v-tap",value:(_setup.handleSwitchAudioRoute),expression:"handleSwitchAudioRoute"}],attrs:{"icon":_setup.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }